export type OntarioPitBullBanStatus = 'named' | 'lookalike';

export const ONTARIO_DOG_OWNERS_LIABILITY_ACT_URL =
  'https://www.ontario.ca/laws/statute/90d16';

const ONTARIO_NAMED_PIT_BULLS =
  /^(pit bull|pitbull|pit bull terrier|american pit bull terrier|staffordshire bull terrier|american staffordshire terrier)$/i;
const PIT_BULL_LOOKALIKES =
  /\bpit\b|pit ?bull|pitsky|\bbully\b|staff|labrabull/i;

export const ontarioPitBullBanStatus = (
  breedName: string
): OntarioPitBullBanStatus | null => {
  const name = breedName.trim().replace(/[\s_-]+/g, ' ');
  if (ONTARIO_NAMED_PIT_BULLS.test(name)) return 'named';
  if (PIT_BULL_LOOKALIKES.test(name)) return 'lookalike';
  return null;
};
